import {getListAcceptorCategories} from '../../redux/actions/acceptors/index';
import {acceptorCategoriesSelector} from '../../redux/selectors/acceptors/index';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import * as React from 'react';
import {getAcceptors} from '../../redux/actions/acceptors';
import {acceptorsListSelector} from '../../redux/selectors/acceptors';

export const useAcceptorsResolver = () => {
  const dispatch = useAppDispatch();
  const acceptors = useSelector(acceptorsListSelector());
  const acceptorCategories = useSelector(acceptorCategoriesSelector());

  React.useEffect(() => {
    if (!acceptors) {
      dispatch(getAcceptors());
    }
  }, [acceptors]);

  React.useEffect(() => {
    if (!acceptorCategories) {
      dispatch(getListAcceptorCategories());
    }
  }, [acceptorCategories]);
};
